import React from "react";
import qrcode from "../../Images/qrcode.jpeg";
const BookingInstructions = () => {
  const upiId = "skadventures@cnrb"; // Your UPI ID
  const name = "SKAdventures";

  return (
    <div className="bg-white py-4 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto rounded-lg shadow-md mb-8">
      <h2 className="text-2xl font-bold text-blue-500 mb-6 sm:text-3xl lg:text-4xl text-center">
        Booking Instructions
      </h2>

      <ol className="list-decimal list-inside text-gray-700 space-y-4 text-base sm:text-lg lg:text-xl">
        <li>
          To secure your reservation, kindly make a payment using the provided
          QR code below. Please verify the name (
          <span className="font-semibold text-gray-800">{name}</span>).
        </li>
        <li>
          After completing the payment, please share a screenshot of the
          transaction with us via WhatsApp for verification.{" "}
          <a
            href="https://wa.me/9371939191"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline font-medium"
          >
            Click here to send screenshot
          </a>
        </li>
        <li>
          Once your payment is confirmed and verified, you will receive a
          confirmation message on WhatsApp along with a Google Form to collect
          further details.
        </li>
      </ol>

      {/* QR Code */}
      <div className="flex justify-center mt-8">
        <img
          src={qrcode}
          alt="UPI QR Code"
          className="w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 rounded-md shadow-lg transition-transform transform hover:scale-105"
        />
      </div>

      {/* UPI Details */}
      <div className="mt-6 text-center">
        <p className="text-gray-800 font-semibold text-lg mb-4">{upiId}</p>
        {/* <button
          onClick={copyToClipboard}
          className="bg-blue-600 text-white px-5 py-2 rounded-md hover:bg-blue-700 transition duration-300"
        >
          Copy UPI ID
        </button> */}
      </div>
    </div>
  );
};

export default BookingInstructions;
